const faqItems = [
  {
    q: '51吃瓜app在哪里可以下载？',
    a: '您可以直接在本页面点击下载按钮获取51吃瓜app最新版本安装包。我们提供安卓APK直装包和苹果iOS客户端两种版本，所有安装包均经过安全检测，请放心下载使用。',
  },
  {
    q: '51吃瓜轻量版和完整版有什么区别？',
    a: '51吃瓜轻量版针对存储空间有限的设备进行了优化，安装包体积更小、运行更流畅，同时保留了核心的吃瓜资讯浏览功能。完整版则提供更丰富的互动功能和个性化推荐，适合追求完整体验的用户。',
  },
  {
    q: '苹果手机如何安装51吃瓜网app？',
    a: '苹果用户可以通过本页面提供的iOS客户端链接进行安装。安装前请确保在「设置-通用-设备管理」中信任企业级应用证书，安装完成后即可正常使用所有功能。',
  },
  {
    q: '51吃瓜app安全吗？会不会泄露隐私？',
    a: '51吃瓜app严格遵守用户隐私保护规范，所有数据传输均采用加密协议。我们不会收集与资讯浏览无关的个人敏感信息，用户数据仅用于优化内容推荐体验，请放心使用。',
  },
  {
    q: '安卓下载后为什么提示无法安装？',
    a: '请在手机设置中开启「允许安装未知来源应用」选项（不同品牌手机路径可能不同，通常在「设置-安全」或「设置-应用管理」中），开启后重新点击安装包即可正常安装。',
  },
  {
    q: '51吃瓜app每天更新几次内容？',
    a: '51吃瓜app保持7×24小时全天候内容更新机制，热门话题实时追踪、重大事件即时推送。编辑团队会在每天早、中、晚三个时段进行集中的内容精选和话题整理，确保您不会错过任何精彩瓜料。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            关于51吃瓜app下载和使用的常见疑问解答
          </p>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-lg p-5 border border-background-200/60"
            >
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}